import { IBookmarkedEntitiesType, IEntityType } from '../types'

let entitiesMapByIdCache: Record<string, string> = {}
let entitiesNameMapByTableNameCache: Record<string, string> = {}

export const setEntitiesMapByIdCache = (
  map: Record<string, string> | undefined
) => {
  entitiesMapByIdCache = map ?? {}
}

export const setEntitiesNameMapByTableNameCache = (
  map: Record<string, string> | undefined
) => {
  entitiesNameMapByTableNameCache = map ?? {}
}

export const getEntityNameByTableName = (
  tableName: string | null | undefined
): string | undefined => {
  if (!tableName?.trim()) return undefined
  return entitiesNameMapByTableNameCache[tableName]
}

export const getEntityNameById = (
  entityId: string | number | null | undefined
): string | undefined => {
  if (entityId == null || String(entityId).trim() === '') return undefined
  return entitiesMapByIdCache[String(entityId)]
}

export const resolveEntityName = (
  entityName: string | null | undefined,
  entityId: string | number | null | undefined
): string | undefined => {
  const trimmedName = entityName?.trim()
  if (trimmedName) {
    const logicalEntityName = getEntityNameByTableName(trimmedName)
    if (logicalEntityName) {
      return logicalEntityName
    }
    return trimmedName
  }

  if (entityId == null || String(entityId).trim() === '') return undefined

  return getEntityNameById(entityId)
}

export const filterNonAgentVisibleEntitiesFromBookmark = (
  bookmarkEntities?: IBookmarkedEntitiesType[],
  allEntities?: IEntityType[]
) => {
  if (!bookmarkEntities) return []
  if (!allEntities) return []
  return bookmarkEntities.filter((be) =>
    allEntities.some((e) => {
      return e.id === be.id && e.agent_visibility
    })
  )
}
